export type PointPosition = {
  isFirstPoint: boolean;
  isLastPoint: boolean;
};
import {type ChartAggOption} from '../../../generated/graphql';
import {
  type HistoryRecord,
  type SafeAreaPoint,
  type SafePoint,
  type ValidHistoryKey,
} from './types';
import {getSafeYKey} from './util';

export type PointWithMeta =
  | (Partial<HistoryRecord> & SafePoint)
  | (Partial<HistoryRecord> & SafeAreaPoint);

// mutation function which extends a point with any other metric values
// required to compute expressions later on
export function extendPoint(
  point: PointWithMeta,
  historyPoint: HistoryRecord,
  metrics: string[],
  pointType: ChartAggOption | undefined
) {
  if (!point.expressionValues) {
    point.expressionValues = {};
  }
  metrics.forEach(function extendPointMetric(metric) {
    const yKey = getSafeYKey({
      yMetricKey: metric,
      record: historyPoint,
      aggType: pointType,
    });
    if (yKey in historyPoint) {
      point.expressionValues![metric] = Number(historyPoint[yKey]);
    }
  });
}

export function buildTimePoint(
  historyPoint: HistoryRecord,
  time: {
    value: number;
    unit: 'seconds' | 'milliseconds';
  }
) {
  const suffixes = ['Min', 'Avg', 'Max', 'Last', ''] as const;
  const startTime = time.unit === 'seconds' ? time.value : time.value / 1000;
  suffixes.forEach(suffix => {
    if (
      typeof historyPoint[`_timestamp${suffix}` as ValidHistoryKey] ===
        'number' &&
      historyPoint[`_absolute_runtime${suffix}` as ValidHistoryKey] ===
        undefined
    ) {
      historyPoint[`_absolute_runtime${suffix}` as ValidHistoryKey] =
        (historyPoint[`_timestamp${suffix}` as ValidHistoryKey] as number) -
        startTime;
    }
  });
}
